import { render, staticRenderFns } from "./ChangePasswordComp.vue?vue&type=template&id=7325da06&lang=true&"
import script from "./ChangePasswordComp.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports